import React, { useCallback, useEffect, useState } from 'react';

import { FormPessoa } from '../../../components/FormPessoas'
import { ErrorRetrievingData } from '../../../components/ErrorRetrievingData';
import MenuMain from '../../../MenuMain';
import { AppFooter } from '../../../AppFooter';

export default function EditarPessoasPage(props) {

    const [isLoading, setIsLoading] = useState(false);
    const [errorRetrievingData, setErrorRetrievingData] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [idPessoa] = useState(props.match.params.id);

    return (
        <>
            <MenuMain>
                {
                    errorRetrievingData ?
                        <ErrorRetrievingData
                            errorMessage={errorMessage}
                            isLoading={isLoading}
                        />
                        :
                        
                            <FormPessoa
                                isEditing={true}
                                isLoading={isLoading}
                            />
                        
                }
            </MenuMain>
            <AppFooter />
        </>
    );
}
